import { render, staticRenderFns } from "./HtmlView.vue?vue&type=template&id=08c96f04"
import script from "./HtmlView.vue?vue&type=script&lang=js"
export * from "./HtmlView.vue?vue&type=script&lang=js"
import style0 from "./HtmlView.vue?vue&type=style&index=0&id=08c96f04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports